import React from 'react'

const Disconnect = props => (
    <svg {...props}>
        <path d="M54.424 28.382a1.001 1.001 0 00-.217-1.091L42.208 15.293a.999.999 0 10-1.414 1.414L51.087 27H20.501a1 1 0 100 2h30.586L40.794 39.293a.999.999 0 101.414 1.414l11.999-11.999c.092-.092.166-.203.217-.326z"></path>
        <path d="M36.501 33a1 1 0 00-1 1v20h-32V2h32v20a1 1 0 102 0V1a1 1 0 00-1-1h-34a1 1 0 00-1 1v54a1 1 0 001 1h34a1 1 0 001-1V34a1 1 0 00-1-1z"></path>
    </svg>
)

export default Disconnect
